// App.jsx
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import 'jsoneditor/dist/jsoneditor.css';
import './farmDashboard.css';
import AppShell from './components/AppShell';
import FarmDashboard from './pages/farmDashboard';
import TrayManager from './pages/trayManager';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import TaskManager from './pages/taskManager';
import RequireAuth from './RequireAuth';
import Login from './pages/Login';
import { getToken, clearToken, getTokenExpiry } from './lib/auth';
import SettingsPage from './pages/settingsPage';
import ProductsPage from './pages/productsPage';
import AnalyticsDashboard from './pages/siteStats';
import SalesPage from './pages/SalesPage';
import AccountingPage from './pages/AccountingPage';
import SubscribersPage from './pages/SubscribersPage';
import EmailStudio from './pages/EmailStudio';
import HarvestsPage from './pages/HarvestsPage';
import ReviewsPage from './pages/ReviewsPage';
import LeafletsPage from './pages/LeafletsPage';
import BriefingsPage from './pages/BriefingsPage';
import AiActivityPage from './pages/AiActivityPage';
import DesktopStatusReporter from './components/DesktopStatusReporter';

function App() {
  useEffect(() => {
    const timer = { current: null };

    const schedule = () => {
      clearTimeout(timer.current);
      const token = getToken();
      if (!token) return;
      const exp = getTokenExpiry(token);
      if (!exp) return;
      const delay = exp - Date.now();
      if (delay <= 0) {
        clearToken();
        window.location.replace('/login');
        return;
      }
      timer.current = setTimeout(() => {
        clearToken();
        window.location.replace('/login');
      }, delay);
    };

    schedule();

    const onStorage = (e) => { if (e.key === 'accessToken') schedule(); };
    window.addEventListener('storage', onStorage);
    return () => {
      clearTimeout(timer.current);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  return (
    <DndProvider backend={HTML5Backend}>
      <Router>
        <DesktopStatusReporter />
        <AppShell>
          <Routes>
            {/* Public route */}
            <Route path="/login" element={<Login />} />

            {/* Protected routes */}
            <Route element={<RequireAuth />}>
              <Route path="/" element={<FarmDashboard />} />
              <Route path="/tray-manager" element={<TrayManager />} />
              <Route path="/harvests" element={<HarvestsPage />} />
              <Route path="/task-manager" element={<TaskManager />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/farm-inbox" element={<Navigate to="/email-studio" replace />} />
              <Route path="/analytics" element={<AnalyticsDashboard />} />
              <Route path="/orders" element={<SalesPage />} />
              <Route path="/accounting" element={<AccountingPage />} />
              <Route path="/subscribers" element={<SubscribersPage />} />
              <Route path="/email-studio" element={<EmailStudio />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/leaflets" element={<LeafletsPage />} />
              <Route path="/briefings" element={<BriefingsPage />} />
              <Route path="/ai-activity" element={<AiActivityPage />} />
            </Route>

            {/* Optional 404 */}
            <Route path="*" element={<div className="dashboard-container"><p className="muted">Not found.</p></div>} />
          </Routes>
        </AppShell>
      </Router>
    </DndProvider>
  );
}

export default App;
